(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["detailsproductmoice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scriptId = 'moice-google-maps-reviews-api';
    var callbackName = '__moiceGoogleMapsReviewsLoaded';

    function loadGoogleMaps(apiKey) {
      if (window.google && window.google.maps && window.google.maps.importLibrary) {
        return Promise.resolve(window.google);
      }

      if (window.moiceGoogleMapsReviewsPromise) {
        return window.moiceGoogleMapsReviewsPromise;
      }

      window.moiceGoogleMapsReviewsPromise = new Promise(function (resolve, reject) {
        var existingScript = document.getElementById(scriptId);

        window[callbackName] = function () {
          resolve(window.google);
        };

        if (existingScript) {
          existingScript.addEventListener('load', function () {
            if (window.google) {
              resolve(window.google);
            } else {
              reject(new Error('Google Maps unavailable'));
            }
          }, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        var script = document.createElement('script');
        script.id = scriptId;
        script.async = true;
        script.defer = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&v=weekly&loading=async&libraries=places&callback=' + callbackName;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.moiceGoogleMapsReviewsPromise;
    }

    function getConfig(section) {
      var limit = parseInt(section.dataset.googleReviewLimit || '3', 10);

      if (Number.isNaN(limit)) {
        limit = 3;
      }

      return {
        enabled: section.dataset.googleEnabled === 'true',
        apiKey: section.dataset.googleApiKey || '',
        placeId: section.dataset.googlePlaceId || '',
        reviewLimit: Math.max(1, Math.min(5, limit)),
        loadingText: section.dataset.googleLoadingText || 'Loading Google reviews...',
        errorText: section.dataset.googleErrorText || 'Google reviews could not load right now.',
        emptyText: section.dataset.googleEmptyText || 'No Google reviews were found.',
        orderNotice: section.dataset.googleOrderNotice || '',
        mapsLinkLabel: section.dataset.googleMapsLinkLabel || 'View on Google Maps',
        reviewLinkLabel: section.dataset.googleReviewLinkLabel || 'View review',
        reportLinkLabel: section.dataset.googleReportLinkLabel || 'Report review'
      };
    }

    function setStatus(section, text, hidden) {
      var status = section.querySelector('[data-mig-google-status]');

      if (!status) {
        return;
      }

      status.textContent = text || '';
      status.hidden = hidden || !text;
    }

    function firstAvailable(values) {
      var index;

      for (index = 0; index < values.length; index += 1) {
        if (values[index]) {
          return values[index];
        }
      }

      return '';
    }

    function buildStars(rating) {
      var number = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));

      return new Array(number + 1).join('\u2605') + new Array(6 - number).join('\u2606');
    }

    function initials(name) {
      var parts = String(name || '').trim().split(/\s+/).slice(0, 2);
      var value = parts.map(function (part) {
        return part.charAt(0);
      }).join('').toUpperCase();

      return value || 'G';
    }

    function setAvatar(card, author) {
      var avatar = card.querySelector('[data-mig-review-avatar]');
      var name = author && author.displayName ? author.displayName : '';
      var imageUrl = author && author.photoURI ? author.photoURI : '';
      var image;

      if (!avatar) {
        return;
      }

      avatar.innerHTML = '';
      avatar.classList.remove('is-initials');

      if (imageUrl) {
        image = document.createElement('img');
        image.src = imageUrl;
        image.alt = name;
        image.loading = 'lazy';
        avatar.appendChild(image);
        return;
      }

      avatar.classList.add('is-initials');
      avatar.textContent = initials(name);
    }

    function appendMeta(meta, text, href) {
      var node;

      if (!meta || !text) {
        return;
      }

      if (href) {
        node = document.createElement('a');
        node.href = href;
        node.target = '_blank';
        node.rel = 'noopener';
      } else {
        node = document.createElement('span');
      }

      node.textContent = text;
      meta.appendChild(node);
    }

    function formatVisitDate(review) {
      var month = review && typeof review.visitDateMonth === 'number' ? review.visitDateMonth : null;
      var year = review && review.visitDateYear ? review.visitDateYear : null;

      if (month === null || !year) {
        return '';
      }

      try {
        return new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(new Date(year, month, 1));
      } catch (error) {
        return '';
      }
    }

    function renderReview(card, reviews, index, config) {
      var review = reviews[index];
      var author = review.authorAttribution || {};
      var authorName = author.displayName || '';
      var authorLink = card.querySelector('[data-mig-author-link]');
      var authorText = card.querySelector('[data-mig-reviewer-name]');
      var quote = card.querySelector('[data-mig-review-text]');
      var stars = card.querySelector('[data-mig-review-stars]');
      var meta = card.querySelector('[data-mig-review-meta]');
      var reviewText = review.text || review.originalText || '';
      var visitDate = formatVisitDate(review);

      setAvatar(card, author);

      if (authorLink && author.uri) {
        authorLink.href = author.uri;
        authorLink.textContent = authorName;
        authorLink.hidden = false;

        if (authorText) {
          authorText.hidden = true;
        }
      } else if (authorText) {
        if (authorLink) {
          authorLink.hidden = true;
        }

        authorText.textContent = authorName;
        authorText.hidden = !authorName;
      }

      if (quote) {
        quote.textContent = reviewText;
        quote.hidden = !reviewText;
      }

      if (stars) {
        stars.textContent = buildStars(review.rating);
      }

      if (meta) {
        meta.innerHTML = '';
        appendMeta(meta, review.relativePublishTimeDescription, '');

        if (visitDate) {
          appendMeta(meta, 'Visited ' + visitDate, '');
        }

        appendMeta(meta, config.reviewLinkLabel, review.googleMapsURI || review.googleMapsUri || '');
        appendMeta(meta, config.reportLinkLabel, review.flagContentURI || review.flagContentUri || '');
        meta.hidden = !meta.children.length;
      }
    }

    function updateDots(card, index) {
      var dots = card.querySelectorAll('.mig-dots button');

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-pressed', dotIndex === index ? 'true' : 'false');
      });
    }

    function showReview(card, reviews, index, config) {
      var nextIndex = (index + reviews.length) % reviews.length;

      card.dataset.migReviewIndex = String(nextIndex);
      renderReview(card, reviews, nextIndex, config);
      updateDots(card, nextIndex);
    }

    function setupControls(card, reviews, config) {
      var arrow = card.querySelector('[data-mig-review-next]');
      var dots = card.querySelector('.mig-dots');
      var index;
      var button;

      if (arrow) {
        arrow.hidden = reviews.length < 2;
        arrow.addEventListener('click', function () {
          var current = parseInt(card.dataset.migReviewIndex || '0', 10);

          showReview(card, reviews, current + 1, config);
        });
      }

      if (!dots) {
        return;
      }

      dots.innerHTML = '';

      if (reviews.length < 2) {
        dots.hidden = true;
        return;
      }

      dots.hidden = false;
      dots.removeAttribute('aria-hidden');

      for (index = 0; index < reviews.length; index += 1) {
        button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Show review ' + (index + 1));
        button.dataset.index = String(index);

        button.addEventListener('click', function (event) {
          showReview(card, reviews, parseInt(event.currentTarget.dataset.index || '0', 10), config);
        });

        dots.appendChild(button);
      }

      updateDots(card, 0);
    }

    function updateScore(card, place) {
      var score = card.querySelector('[data-mig-review-score]');
      var stars = card.querySelector('[data-mig-score-stars]');
      var caption = card.querySelector('[data-mig-review-caption]');
      var rating = Number(place.rating || 0);
      var count = Number(place.userRatingCount || 0);

      if (score && rating) {
        score.textContent = String(Math.round(rating * 10) / 10);
      }

      if (stars && rating) {
        stars.textContent = buildStars(rating);
      }

      if (caption && count) {
        caption.textContent = 'Based on ' + count + ' ' + (count === 1 ? 'Google review' : 'Google reviews');
      }
    }

    function showGoogleAttribution(card, place, config) {
      var attribution = card.querySelector('[data-mig-google-attribution]');
      var link = card.querySelector('[data-mig-google-place-link]');
      var notice = card.querySelector('[data-mig-google-notice]');
      var mapsLinks = place.googleMapsLinks || {};
      var placeLink = firstAvailable([
        mapsLinks.reviewsURI,
        mapsLinks.placeURI,
        place.googleMapsURI,
        place.googleMapsUri
      ]);

      if (attribution) {
        attribution.hidden = false;
      }

      if (link && placeLink) {
        link.href = placeLink;
        link.textContent = config.mapsLinkLabel;
        link.hidden = false;
      } else if (link) {
        link.hidden = true;
      }

      if (notice) {
        notice.textContent = config.orderNotice;
        notice.hidden = !config.orderNotice;
      }
    }

    function loadReviews(section) {
      var config = getConfig(section);
      var card = section.querySelector('[data-mig-review-card]');

      if (!config.enabled || !config.apiKey || !config.placeId || !card) {
        return;
      }

      card.setAttribute('aria-busy', 'true');
      setStatus(section, config.loadingText, false);

      loadGoogleMaps(config.apiKey)
        .then(function (google) {
          return google.maps.importLibrary('places');
        })
        .then(function (placesLibrary) {
          var Place = placesLibrary.Place;
          var place = new Place({ id: config.placeId });

          return place.fetchFields({
            fields: ['displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsURI', 'googleMapsLinks']
          }).then(function () {
            return place;
          });
        })
        .then(function (place) {
          var reviews = Array.isArray(place.reviews) ? place.reviews.filter(function (review) {
            return review && (review.text || review.originalText || review.rating);
          }).slice(0, config.reviewLimit) : [];

          card.removeAttribute('aria-busy');

          if (!reviews.length) {
            setStatus(section, config.emptyText, false);
            return;
          }

          card.classList.add('is-google-loaded');
          updateScore(card, place);
          showGoogleAttribution(card, place, config);
          setStatus(section, '', true);
          showReview(card, reviews, 0, config);
          setupControls(card, reviews, config);
        })
        .catch(function () {
          card.removeAttribute('aria-busy');
          setStatus(section, config.errorText, false);
        });
    }

    function init() {
      document.querySelectorAll('[data-mig-google-reviews]').forEach(function (section) {
        if (section.dataset.migGoogleReady === 'true') {
          return;
        }

        section.dataset.migGoogleReady = 'true';
        loadReviews(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) {
        event.target.querySelectorAll('[data-mig-google-reviews]').forEach(function (section) {
          section.dataset.migGoogleReady = 'false';
        });
      }

      init();
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product"]) return;
  try {
    
if (!customElements.get('moice-collection-results')) {
  customElements.define('moice-collection-results', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.requests = new AbortController();
      this.grid = this.querySelector('#product-grid');
      if (!this.grid || !Number(this.dataset.total)) return;
      this.pageSize = Number(this.dataset.pageSize);
      this.firstPage = Number(this.dataset.page);
      this.lastPage = this.firstPage;
      this.totalPages = Number(this.dataset.pages);
      this.baseUrl = new URL(window.location.href);
      this.baseUrl.searchParams.delete('sections');
      this.baseUrl.searchParams.delete('section_id');
      this.baseUrl.searchParams.set('view', this.dataset.view);
      this.promotion = this.grid.querySelector(':scope > .promotion');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-moice-load-more]');
        if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.loadMore(false);
      }, { signal: this.events.signal });
      this.ready = this.prepare().catch(error => {
        if (error.name !== 'AbortError') console.warn('Collection availability ordering could not finish.', error);
        return false;
      });
      this.ready.then(success => {
        if (!success || !this.isConnected || this.dataset.pagination !== 'infinit_scrolling') return;
        const link = this.querySelector('[data-moice-load-more]');
        if (!link || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.loadMore(true);
        }, { rootMargin: '200px' });
        this.observer.observe(link);
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.requests?.abort();
      this.observer?.disconnect();
      this.events = null;
    }

    readProducts(grid) {
      return Array.from(grid.querySelectorAll(':scope > [data-moice-product-id]'), node => ({
        id: node.dataset.moiceProductId,
        available: node.dataset.moiceAvailable === 'true',
        node
      }));
    }

    async prepare() {
      const pages = new Array(this.totalPages);
      pages[this.firstPage - 1] = this.readProducts(this.grid);
      const queue = Array.from({ length: this.totalPages }, (_, index) => index + 1)
        .filter(page => page !== this.firstPage);
      const worker = async () => {
        while (queue.length) {
          const page = queue.shift();
          const url = new URL(this.baseUrl);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('page', String(page));
          const response = await fetch(url.toString(), { signal: this.requests.signal });
          if (!response.ok) throw new Error('Collection request failed: ' + response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = Array.from(html.querySelectorAll('moice-collection-results'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          if (!result || Number(result.dataset.page) !== page || result.dataset.total !== this.dataset.total) {
            throw new Error('Collection changed while loading its pages.');
          }
          const grid = result.querySelector('#product-grid');
          if (!grid) throw new Error('Collection grid is missing.');
          pages[page - 1] = this.readProducts(grid);
          if (!this.promotion) this.promotion = grid.querySelector(':scope > .promotion');
        }
      };
      await Promise.all(Array.from({ length: Math.min(3, queue.length) }, worker));
      if (!this.isConnected || this.requests.signal.aborted) return false;
      const products = pages.flat();
      if (products.length !== Number(this.dataset.total) || new Set(products.map(product => product.id)).size !== products.length) {
        throw new Error('Collection pages are incomplete.');
      }
      this.products = products.filter(product => product.available)
        .concat(products.filter(product => !product.available));
      this.render();
      return true;
    }

    render() {
      const start = (this.firstPage - 1) * this.pageSize;
      const end = Math.min(this.lastPage * this.pageSize, this.products.length);
      const existing = new Map(this.readProducts(this.grid).map(product => [product.id, product.node]));
      const nodes = this.products.slice(start, end).map(product =>
        existing.get(product.id) || document.importNode(product.node, true)
      );
      const promotionIndex = Number(this.dataset.promotionPosition) - 1;
      if (this.promotion && promotionIndex >= start && promotionIndex < end) {
        nodes.splice(promotionIndex - start, 0, this.promotion);
      }
      const children = Array.from(this.grid.children);
      if (children.length !== nodes.length || children.some((node, index) => node !== nodes[index])) {
        const focused = this.contains(document.activeElement) ? document.activeElement : null;
        this.grid.replaceChildren(...nodes);
        if (focused?.isConnected) focused.focus({ preventScroll: true });
        if (typeof initLazyloadItem === 'function') initLazyloadItem();
      }
      this.dataset.stockOrdered = 'true';
      this.dispatchEvent(new CustomEvent('moice:collection:updated', { bubbles: true }));
    }

    async loadMore(automatic) {
      const link = this.querySelector('[data-moice-load-more]');
      if (!link || this.loading) return;
      this.loading = true;
      link.setAttribute('aria-busy', 'true');
      try {
        const success = await this.ready;
        if (!this.isConnected) return;
        if (!success) {
          this.observer?.disconnect();
          if (!automatic) window.location.assign(link.href);
          return;
        }
        if (this.lastPage >= this.totalPages) return;
        const firstNewIndex = (this.lastPage - this.firstPage + 1) * this.pageSize;
        this.lastPage += 1;
        this.render();
        if (this.lastPage >= this.totalPages) {
          this.observer?.disconnect();
          if (!automatic && document.activeElement === link) {
            this.grid.querySelectorAll(':scope > [data-moice-product-id]')[firstNewIndex]
              ?.querySelector('a[href]')?.focus({ preventScroll: true });
          }
          this.querySelector('[data-moice-pagination]')?.remove();
        } else {
          const next = new URL(this.baseUrl);
          next.searchParams.set('page', String(this.lastPage + 1));
          link.href = next.toString();
        }
      } finally {
        this.loading = false;
        link.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('moice-product-page')) {
  customElements.define('moice-product-page', class extends HTMLElement {
    connectedCallback() {
      const state = this.querySelector('[data-product-state]');
      if (!state || this.events) return;
      this.state = JSON.parse(state.textContent);
      this.events = new AbortController();
      this.requestNumber = 0;
      this.busy = false;
      this.confirmedSelection = this.selectedValues();
      const signal = this.events.signal;
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.setBusy(false);
      }, { signal });
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('keydown', event => this.onKeyDown(event), { signal });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-quantity-input]')) this.syncQuantity();
      }, { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-quantity-input]')) this.normalizeQuantity();
      }, { signal });
      this.syncQuantity();
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-product-form]')) return;
        event.preventDefault();
        this.addToCart(false);
      }, { signal });
      this.addEventListener('toggle', event => {
        const row = event.target;
        if (!row.matches('details') || !row.open) return;
        const accordion = row.closest('[data-accordion-mode="single"]');
        accordion?.querySelectorAll('details[open]').forEach(other => {
          if (row !== other) other.open = false;
        });
      }, { capture: true, signal });
      const main = this.querySelector('[data-gallery-main]');
      if (main) {
        if (main.dataset.imageZoom === 'true') {
          main.addEventListener('pointermove', event => {
            if (event.pointerType === 'touch') return;
            const bounds = main.getBoundingClientRect();
            if (!bounds.width || !bounds.height) return;
            const x = Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100));
            const y = Math.max(0, Math.min(100, ((event.clientY - bounds.top) / bounds.height) * 100));
            main.style.setProperty('--klp-zoom-x', `${x}%`);
            main.style.setProperty('--klp-zoom-y', `${y}%`);
            main.classList.add('is-zooming');
          }, { signal });
          main.addEventListener('pointerleave', () => this.resetImageZoom(main), { signal });
          main.addEventListener('pointercancel', () => this.resetImageZoom(main), { signal });
        }
        this.resizeObserver = new ResizeObserver(() => this.syncGallery());
        this.resizeObserver.observe(main);
        window.addEventListener('resize', () => this.syncGallery(), { signal });
        this.addEventListener('load', () => this.syncGallery(), { capture: true, signal });
        this.syncGallery();
      }
      this.querySelectorAll('[data-accordion-mode="single"]').forEach(accordion => {
        accordion.querySelectorAll('details[open]').forEach((row, index) => {
          if (index) row.open = false;
        });
      });
      const activeThumb = this.querySelector('[data-thumb][aria-pressed="true"]');
      const revealGallery = this.dataset.revealGallery === 'true';
      const animateGallery = this.dataset.animateGallery === 'true';
      delete this.dataset.revealGallery;
      delete this.dataset.animateGallery;
      if (activeThumb) this.queueThumbnailScroll(activeThumb.dataset.mediaId, { animate: animateGallery, revealGallery, initial: !animateGallery });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.variantRequest?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.thumbnailScrollFrame);
      this.events = null;
    }

    selectedValues() {
      return [...this.querySelectorAll('[data-option-group]')].map(group =>
        group.querySelector('[data-option-value-id][aria-pressed="true"]')?.dataset.optionValueId
      ).filter(Boolean);
    }

    feedback(message, isError = false) {
      const target = this.querySelector('[data-feedback]');
      if (!target) return;
      target.textContent = message;
      target.classList.toggle('is-error', isError);
    }

    setBusy(busy, lockOptions = false) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('[data-add-button], [data-buy-button]').forEach(button => {
        button.disabled = busy || !this.state.variant?.available;
      });
      this.querySelectorAll('[data-option-value-id]').forEach(button => {
        button.disabled = busy && lockOptions;
      });
      const input = this.querySelector('[data-variant-id]');
      if (input) input.disabled = busy || !this.state.variant?.available;
      this.syncQuantity();
    }

    quantityLimits(input) {
      const min = Math.max(1, Number(input.min) || 1);
      const step = Math.max(1, Number(input.step) || 1);
      const max = input.max ? min + Math.floor((Number(input.max) - min) / step) * step : Infinity;
      return { min, max, step };
    }

    syncQuantity() {
      const input = this.querySelector('[data-quantity-input]');
      if (!input) return;
      const { min, max } = this.quantityLimits(input);
      const value = input.valueAsNumber;
      const blocked = this.busy || !this.state.variant?.available;
      input.readOnly = blocked;
      this.querySelectorAll('[data-quantity-adjust]').forEach(button => {
        button.disabled = blocked || (button.dataset.quantityAdjust === 'minus'
          ? !Number.isFinite(value) || value <= min
          : Number.isFinite(value) && value >= max);
      });
    }

    normalizeQuantity() {
      const input = this.querySelector('[data-quantity-input]');
      if (!input || input.readOnly) return;
      const { min, max, step } = this.quantityLimits(input);
      const value = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
      input.value = String(Math.min(max, Math.max(min, min + Math.round((value - min) / step) * step)));
      this.syncQuantity();
    }

    adjustQuantity(direction) {
      const input = this.querySelector('[data-quantity-input]');
      if (!input || input.readOnly || this.busy || !this.state.variant?.available) return;
      const { min, max, step } = this.quantityLimits(input);
      const value = input.valueAsNumber;
      let next = min;
      if (Number.isFinite(value)) {
        const index = direction === 'plus' ? Math.floor((value - min) / step) + 1 : Math.ceil((value - min) / step) - 1;
        next = Math.min(max, Math.max(min, min + index * step));
      }
      input.value = String(next);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    selectOption(button) {
      const group = button.closest('[data-option-group]');
      group.querySelectorAll('[data-option-value-id]').forEach(value => {
        const selected = value === button;
        value.classList.toggle('is-selected', selected);
        value.setAttribute('aria-pressed', String(selected));
      });
      const display = group.querySelector('[data-option-display]');
      if (display) display.textContent = button.dataset.value;
    }

    onClick(event) {
      const sizeChartOpen = event.target.closest('[data-size-chart-open]');
      if (sizeChartOpen) {
        const dialog = this.querySelector('[data-size-chart-dialog]');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }
      const sizeChartClose = event.target.closest('[data-size-chart-close]');
      if (sizeChartClose) {
        this.querySelector('[data-size-chart-dialog]')?.close();
        return;
      }
      const sizeChartDialog = event.target.closest('[data-size-chart-dialog]');
      if (sizeChartDialog && event.target === sizeChartDialog) {
        sizeChartDialog.close();
        return;
      }
      const quantityButton = event.target.closest('[data-quantity-adjust]');
      if (quantityButton) {
        event.preventDefault();
        if (!quantityButton.disabled) this.adjustQuantity(quantityButton.dataset.quantityAdjust);
        return;
      }
      const option = event.target.closest('[data-option-value-id]');
      if (option && !option.disabled) {
        event.preventDefault();
        this.selectOption(option);
        this.updateVariant(option);
        return;
      }
      const thumb = event.target.closest('[data-thumb]');
      if (thumb) this.showMedia(thumb.dataset.mediaId);
      const tab = event.target.closest('[data-tab]');
      if (tab) this.activateTab(tab.dataset.tab);
      if (event.target.closest('[data-buy-button]')) this.addToCart(true);
    }

    async updateVariant(button) {
      this.variantRequest?.abort();
      const controller = new AbortController();
      this.variantRequest = controller;
      const requestNumber = ++this.requestNumber;
      const selectedValues = this.selectedValues();
      const url = new URL(button.dataset.productUrl || this.dataset.productUrl, window.location.origin);
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('option_values', selectedValues.join(','));
      this.setBusy(true);
      this.feedback(this.state.messages.loading);
      try {
        const response = await fetch(url.toString(), { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error();
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (requestNumber !== this.requestNumber || !this.isConnected) return;
        const next = [...html.querySelectorAll('moice-product-page')].find(section =>
          section.dataset.sectionId === this.dataset.sectionId
        );
        const nextStateElement = next?.querySelector('[data-product-state]');
        if (!nextStateElement) throw new Error();
        const nextState = JSON.parse(nextStateElement.textContent);
        const isSameProduct = next.dataset.productId === this.dataset.productId;
        const focusedId = button.id;
        const openRows = [...this.querySelectorAll('[data-accordion] details')].map(row => row.open);
        const activeTab = this.querySelector('[data-tab][aria-selected="true"]')?.dataset.tab;
        const previousQuantity = this.querySelector('[name="quantity"]')?.value;
        const quantityInput = next.querySelector('[name="quantity"]');
        if (isSameProduct && quantityInput && previousQuantity) {
          const quantity = Number(previousQuantity);
          const min = Number(quantityInput.min || quantityInput.value || 1);
          const step = Number(quantityInput.step || 1);
          const max = quantityInput.max ? Number(quantityInput.max) : Infinity;
          if (Number.isInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0) {
            quantityInput.value = String(quantity);
          }
        }
        if (isSameProduct) {
          next.querySelectorAll('[data-accordion] details').forEach((row, index) => {
            row.open = openRows[index] ?? row.open;
          });
        }
        if (this.dataset.updateUrl === 'true') {
          const historyUrl = new URL(window.location.href);
          if (!isSameProduct) historyUrl.pathname = new URL(next.dataset.productUrl, window.location.origin).pathname;
          historyUrl.searchParams.delete('variant');
          historyUrl.searchParams.delete('option_values');
          if (nextState.variant?.id) historyUrl.searchParams.set('variant', nextState.variant.id);
          else historyUrl.searchParams.set('option_values', selectedValues.join(','));
          window.history.replaceState(window.history.state, '', historyUrl);
        }
        next.dataset.updateUrl = this.dataset.updateUrl;
        next.dataset.animateGallery = 'true';
        next.dataset.revealGallery = String(
          Boolean(button.closest('.klp-option-color')) &&
          Boolean(nextState.featuredMediaId) &&
          (!isSameProduct || String(nextState.featuredMediaId) !== String(this.state.featuredMediaId))
        );
        this.replaceWith(next);
        if (isSameProduct && activeTab) next.activateTab(activeTab);
        next.querySelectorAll('[data-option-value-id]').forEach(value => {
          if (value.id === focusedId) value.focus({ preventScroll: true });
        });
        next.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant: nextState.variant, sectionId: next.dataset.sectionId }
        }));
      } catch (error) {
        if (error.name === 'AbortError' || requestNumber !== this.requestNumber) return;
        this.querySelectorAll('[data-option-value-id]').forEach(value => {
          if (this.confirmedSelection.includes(value.dataset.optionValueId)) this.selectOption(value);
        });
        this.setBusy(false);
        this.feedback(this.state.messages.variantError, true);
      }
    }

    syncGallery() {
      const main = this.querySelector('[data-gallery-main]');
      const thumbs = this.querySelector('[data-gallery-thumbs]');
      if (!main || !thumbs) return;
      const mobile = window.matchMedia('(max-width: 768px)').matches;
      const height = main.getBoundingClientRect().height;
      thumbs.style.height = mobile || !height ? '' : `${height}px`;
      thumbs.style.maxHeight = mobile || !height ? '' : `${height}px`;
    }

    queueThumbnailScroll(id, options = {}) {
      cancelAnimationFrame(this.thumbnailScrollFrame);
      this.thumbnailScrollFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.scrollThumbnail(id, options);
      });
    }

    scrollThumbnail(id, { animate = true, revealGallery = false, initial = false } = {}) {
      const gallery = this.querySelector('.klp-gallery');
      const thumbs = this.querySelector('[data-gallery-thumbs]');
      const thumb = [...this.querySelectorAll('[data-thumb]')].find(item => item.dataset.mediaId === String(id));
      if (!gallery || !thumbs || !thumb) return;
      const horizontal = getComputedStyle(thumbs).display === 'contents';
      if (horizontal && initial) return;
      const container = horizontal ? gallery : thumbs;
      if (!container.clientWidth || !container.clientHeight) return;
      const bounds = container.getBoundingClientRect();
      const target = thumb.getBoundingClientRect();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = animate && !reducedMotion ? 'smooth' : 'instant';
      const outside = horizontal
        ? target.left < bounds.left || target.right > bounds.right
        : target.top < bounds.top || target.bottom > bounds.bottom;
      if (outside) {
        const left = horizontal
          ? Math.max(0, Math.min(container.scrollWidth - container.clientWidth,
            container.scrollLeft + target.left - bounds.left - (container.clientWidth - target.width) / 2))
          : container.scrollLeft;
        const top = horizontal
          ? container.scrollTop
          : Math.max(0, Math.min(container.scrollHeight - container.clientHeight,
            container.scrollTop + target.top - bounds.top - (container.clientHeight - target.height) / 2));
        container.scrollTo({ left, top, behavior });
      }
      if (horizontal && revealGallery) {
        const galleryBounds = gallery.getBoundingClientRect();
        if (galleryBounds.top < 96 || galleryBounds.bottom > window.innerHeight) {
          gallery.scrollIntoView({ behavior, block: 'start', inline: 'nearest' });
        }
      }
    }

    resetImageZoom(main = this.querySelector('[data-gallery-main]')) {
      if (!main) return;
      main.classList.remove('is-zooming');
      main.style.removeProperty('--klp-zoom-x');
      main.style.removeProperty('--klp-zoom-y');
    }

    showMedia(id) {
      this.resetImageZoom();
      const template = [...this.querySelectorAll('[data-media-template]')].find(item => item.dataset.mediaTemplate === id);
      const stage = this.querySelector('[data-media-stage]');
      if (!template || !stage) return;
      stage.querySelectorAll('video').forEach(video => video.pause());
      stage.replaceChildren(template.content.cloneNode(true));
      this.querySelectorAll('[data-thumb]').forEach(thumb => {
        const selected = thumb.dataset.mediaId === id;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
        if (selected && this.state.ratioMode === 'auto' && Number(thumb.dataset.mediaRatio) > 0) {
          this.querySelector('[data-gallery-main]').style.aspectRatio = thumb.dataset.mediaRatio;
          this.style.setProperty('--klp-thumb-ar', thumb.dataset.mediaRatio);
        }
      });
      this.syncGallery();
      this.queueThumbnailScroll(id);
    }

    activateTab(id) {
      if (![...this.querySelectorAll('[data-tab]')].some(tab => tab.dataset.tab === id)) return;
      this.querySelectorAll('[data-tab]').forEach(tab => {
        const selected = tab.dataset.tab === id;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => {
        const selected = panel.dataset.panel === id;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });
    }

    onKeyDown(event) {
      const tab = event.target.closest('[data-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = [...this.querySelectorAll('[data-tab]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      this.activateTab(tabs[index].dataset.tab);
      tabs[index].focus();
    }

    async addToCart(buyNow) {
      const form = this.querySelector('[data-product-form]');
      if (this.busy || !this.state.variant?.available || !form?.reportValidity()) return;
      const formData = new FormData(form);
      formData.set('id', String(this.state.variant.id));
      const drawer = document.querySelector('cart-drawer, cart-notification');
      let sectionIds = [];
      if (typeof drawer?.getSectionsToRender === 'function') {
        sectionIds = drawer.getSectionsToRender().map(section => section.id).slice(0, 5);
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }
      this.setBusy(true, true);
      this.feedback(buyNow ? this.state.messages.checkout : this.state.messages.adding);
      let navigating = false;
      try {
        const response = await fetch(this.state.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.state.messages.cartError);
        if (buyNow) {
          navigating = true;
          window.location.assign(this.state.redirectCheckout ? this.state.checkoutUrl : this.state.cartUrl);
          return;
        }
        this.feedback(this.state.messages.added);
        const link = this.querySelector('[data-cart-link]');
        if (link) link.hidden = false;
        if (typeof drawer?.renderContents === 'function' && sectionIds.length && sectionIds.every(id => result.sections?.[id])) {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
          } catch {}
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: result } }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { variantId: this.state.variant.id, item: result } }));
      } catch (error) {
        this.feedback(error.message || this.state.messages.cartError, true);
      } finally {
        if (!navigating) this.setBusy(false);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
